import React from 'react';
import { motion } from 'framer-motion';
interface AnimatedIconProps {
  children: React.ReactNode;
  delay: number;
}
export function AnimatedIcon({
  children,
  delay
}: AnimatedIconProps) {
  return <motion.div initial={{
    scale: 0.8,
    opacity: 0
  }} whileInView={{
    scale: 1,
    opacity: 1
  }} transition={{
    duration: 0.5,
    delay
  }} whileHover={{
    rotate: 2,
    scale: 1.05
  }} className="w-16 h-16 rounded-full bg-dark-green relative flex items-center justify-center" data-id="element-80">
      <div className="absolute inset-0 bg-primary/5 rounded-full blur-md" data-id="element-81" />
      <div className="relative z-10" data-id="element-82">{children}</div>
    </motion.div>;
}